module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "movie-view has-header"
  }, [_c('scroller', {
    attrs: {
      "title": "最受关注图书｜虚构类",
      "type": "hasCover",
      "items": _vm.novel
    }
  }), _vm._v(" "), _c('scroller', {
    attrs: {
      "title": "最受关注图书｜非虚构类",
      "type": "hasCover",
      "items": _vm.reality
    }
  }), _vm._v(" "), _c('scroller', {
    attrs: {
      "title": "豆瓣纸书",
      "type": "hasCover",
      "items": _vm.travel
    }
  }, [_c('div', {
    staticClass: "promItem",
    slot: "promItem"
  }, [_c('img', {
    staticClass: "corver",
    attrs: {
      "src": require("../assets/book_zw.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v("¥ 68")]), _vm._v(" "), _c('p', {
    staticClass: "name"
  }, [_vm._v("造物")]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("改变世界的万物图典，3000幅图里的发明与冒险")])])])]), _vm._v(" "), _c('scroller', {
    attrs: {
      "title": "发现好书",
      "type": "onlyString",
      "items": _vm.bookTags
    }
  }), _vm._v(" "), _c('types'), _vm._v(" "), _c('download-app')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-180beb86"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/BookView.vue
// module id = 192
// module chunks = 0